import {
  vs
} from "./chunk-56TZPABM.js";
import {
  __objRest
} from "./chunk-M54I523Y.js";

// packages/ui-lib/src/layout/getGridProps.ts
import cn from "classnames";

// packages/ui-lib/src/layout/getGridProps.css.ts
var grid = "getGridProps__16h5z6l2";
var xTemplateVar = "var(--_16h5z6l0)";
var xgap = { none: "getGridProps_none__16h5z6l3", xs: "getGridProps_xs__16h5z6l4", small: "getGridProps_small__16h5z6l5", medium: "getGridProps_medium__16h5z6l6", large: "getGridProps_large__16h5z6l7" };
var yTemplateVar = "var(--_16h5z6l1)";
var ygap = { none: "getGridProps_none__16h5z6l8", xs: "getGridProps_xs__16h5z6l9", small: "getGridProps_small__16h5z6la", medium: "getGridProps_medium__16h5z6lb", large: "getGridProps_large__16h5z6lc" };

// packages/ui-lib/src/layout/getGridProps.ts
function getGridProps(_a) {
  var _b = _a, {
    xtemplate,
    ytemplate,
    xgap: xgap2,
    ygap: ygap2
  } = _b, rest = __objRest(_b, [
    "xtemplate",
    "ytemplate",
    "xgap",
    "ygap"
  ]);
  const varStyles = vs([xTemplateVar, xtemplate], [yTemplateVar, ytemplate]);
  const classNames = cn(grid, xgap2 && xgap[xgap2], ygap2 && ygap[ygap2]);
  return [classNames, varStyles, rest];
}

export {
  getGridProps
};
//# sourceMappingURL=chunk-OJGKJJOE.js.map
